module.exports = __webpack_public_path__ + "static/media/bolso (15).b4042c9a.jpg";